import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header';
import { FooterComponent } from './shared/components/footer/footer';
import { AnalyticsService } from './shared/services/analytics';
import { AffiliateTrackingService } from './core/services/affiliate-tracking.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  private readonly analytics = inject(AnalyticsService);
  private readonly affiliateTracking = inject(AffiliateTrackingService);
  protected readonly title = signal('Regency House Cleaning');
}

